import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Col, Row, Input } from "antd";
import { useNavigate } from "react-router-dom";
import Headers from "../../../redux/Actions/Headers/Header";
import SMSList from "./SMSList";

const SMS = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchSender, setSearchSender] = useState("");

  useEffect(() => {
    dispatch(
      Headers.setHeader({
        title: "SMS Blast",
      })
    );
    return () => dispatch(Headers.resetHeader());
  }, [dispatch]);

  return (
    <>
      <Row justify="space-between" align="middle" gutter={[24, 16]} wrap style={{ marginBottom: 16 }}>
        <Col xs={24} md={14} lg={16} xl={18} style={{ minWidth: 0 }}>
          <Input.Search
            placeholder="Search by sender, property or date"
            allowClear
            value={searchSender}
            onChange={(e) => setSearchSender(e.target.value)}
            style={{ width: "100%", maxWidth: 360 }}
            onSearch={(v) => setSearchSender(v)}
          />
        </Col>
        <Col xs={24} md={10} lg={8} xl={6} className="create-button-content">
          <Button className="create-button" onClick={() => navigate("/AAM/sms/create")}>
            Create
          </Button>
        </Col>
      </Row>
      <div className="user-table-box">
        <SMSList searchSender={searchSender} />
      </div>
    </>
  );
};

export default SMS;

